<template>
    <div class="card" v-if="bundle_item.is_boarding_activated === '1'">
        <div class="card-header">
            <div class="row">
                <div class="col-12">
                    <np-checkbox
                        v-if="!isView"
                        :id="`talech_service_is_activated_${bundle_item_key}`"
                        :name="`talech_service_is_activated_${bundle_item_key}`"
                        :no-wrapper="true"
                        :disabled="itemIsDisabled(bundle_item)"
                        :description="bundle_item.service.service_name"
                        :checked="bundle_item.is_boarding_activated === '1'"
                        @change="toggleTalechService(bundle_item)"
                        v-model="bundle_item.is_boarding_activated">
                    </np-checkbox>
                    <span v-else>   {{bundle_item.service.service_name}}</span>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12 col-sm-2 col-md-2 col-lg-2" style="text-align: center">
                    <img width="auto" height="80"  :src="getBundleItemServiceFirstImage(bundle_item)" class="avatar-small">
                </div>
                <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                    <template v-if="itemHasDescription(bundle_item)">
                    <div class="panel-sub-heading headingSmall padding0">
                        <span class="markedBottom">{{lang('description')}}</span>
                    </div>
                    <np-show-less
                        :id="`talech_service_description_${bundle_item_key}`"
                        :description="bundle_item.service.service_description" >
                    </np-show-less>
                    </template>
                </div>
                <div class="col-12 col-sm-3 col-md-3 col-lg-3">
                    <div class="row"  v-if="itemHasServiceCharges(bundle_item)">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                             v-for="(service_charge, service_charge_idx) in bundle_item.service_charges">
                            <np-input
                                v-if="service_charge_idx === 0"
                                :disabled="!is_editable_price"
                                :label="lang('monthly_cost_per_license')"
                                :name="`talech_price_${bundle_item_key}`"
                                :id="`talech_price_${bundle_item_key}`"
                                :rules="['numeric', {'greater_equal_than' : service_charge.minimum_base_charge}, {'less_than_equal' :  service_charge.maximum_base_charge}]"
                                :check_config="false"
                                :no-wrapper="false"
                                :addon-on-left="true"
                                @blur="onUnitNormalise(service_charge, 'service_base_charge', 2)"
                                v-model="service_charge.service_base_charge">
                                <span slot="addon">{{curr}}</span>
                            </np-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <np-input
                                :label="lang('no_of_licences')"
                                :name="`terminal_quantity_${bundle_item_key}`"
                                :id="`terminal_quantity_${bundle_item_key}`"
                                :rules="['is_natural', {'greater_than_equal' : '1'}, {'less_than_equal' : '8'}]"
                                :disabled="!is_editable_quantity"
                                :no-wrapper="false"
                                v-model="bundle_item.terminal_quantity">
                            </np-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import utilMixin from "../utils/mixins";
import applicationMixin from "../utils/application-mixin";
import equipmentMixin from "../utils/equipment-mixin";
import {
    NPCheckBox,
    NPInput,
    NPShowLess,

} from "netpify/components";

export default {
    name: "talech-service",
    mixins: [utilMixin, applicationMixin, equipmentMixin],
    components: {
        'np-input': NPInput,
        'np-checkbox': NPCheckBox,
        'np-show-less': NPShowLess,
    },
    data() {
        return {
            curr:  '£',
        }
    },
    props: {
        bundle_item: {
            default() {
                return {}
            }
        },
        isView: Boolean,
        isBundlePackage: Boolean,
        bundlePackageSelected: Boolean,
        bundle_item_key: {
            default() {
                return {}
            }
        },
    },
    mounted() {
        this.toggleTalechService(this.bundle_item);
    },
    computed: {
        is_editable_quantity: function () {
            if (this.isView) return false;
            if (this.bundle_item.is_boarding_activated !== '1') return false;

            const has_service_api_code = !!this.bundle_item.service && !!this.bundle_item.service.service_api_code;
            if (!has_service_api_code) return false;

            const param = this.talech_service_logic[this.bundle_item.service.service_api_code];
            if (!param) return false;

            return param.is_editable_quantity;
        },
        is_editable_price: function () {
            if (this.isView) return false;
            if (this.bundle_item.is_boarding_activated !== '1') return false;

            const has_service_api_code = !!this.bundle_item.service && !!this.bundle_item.service.service_api_code;
            if (!has_service_api_code) return false;

            const param = this.talech_service_logic[this.bundle_item.service.service_api_code];
            if (!param) return false;

            return param.is_editable_price;
        },
    },
    methods: {
        itemHasDescription: function (bundle_item) {
            return bundle_item.service.hasOwnProperty('service_description') &&
                bundle_item.service.service_description !== '';
        },
        itemIsDisabled: function (bundle_item) {
            return this.isView ? true :  this.equipmentIsDisabled(bundle_item);
        },
        toggleTalechService: function (bundle_item) {
            let has_charges = !!(Array.isArray(this.bundle_item.service_charges) &&
                this.bundle_item.service_charges.length > 0)

            if (bundle_item.is_mandatory === '1' && bundle_item.is_boarding_activated !== '1') {
                bundle_item.is_boarding_activated = '1';
            }

            if (bundle_item.is_boarding_activated === '1') {
                bundle_item.selected = true;
                if (has_charges) {
                    this.bundle_item.service_charges[0].is_selected = '1';
                }
            } else {
                //reset the data
                bundle_item.selected = false;
                this.bundle_item.terminal_quantity = '1';
                if (has_charges) {
                    this.bundle_item.service_charges[0].service_base_charge =
                        this.bundle_item.service_charges[0].default_base_charge;
                }

            }

            this.$emit('terminal-toggled', bundle_item);
        },
    },
}
</script>

<style scoped>
</style>
